import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoginService } from '../../../services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-reset-request',
  templateUrl: './reset-request.component.html',
  styleUrls: ['../../login.component.scss']
})
export class ResetRequestComponent implements OnInit {
  resetPassForm: FormGroup;
  isMailSent: boolean = true;

  constructor(public loginService: LoginService, private fb: FormBuilder, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.resetPassForm = this.fb.group({
      email: ['']
    })
  }

  resetPassword() {
    this.loginService.resetPassword(this.resetPassForm.value).subscribe(
      (success) => {
        this.isMailSent = false;
      },
      (error) => {
        this.snackBar.open(error.error.error, 'close', {
          duration: 4000
        });
      }
    );
  }

}
